import { useState } from 'react';
import LevantamientoPgBandeja from './LevantamientoPgBandeja';
import LevantamientoYichangBandeja from './LevantamientoYichangBandeja';

export type ClienteLevantamiento = 'pg' | 'yichang';

/** Solo la última elección del que mira: una comodidad de este navegador, no un dato. */
const CLAVE_CLIENTE = 'treid.levantamientoInf.cliente';

function clienteGuardado(): ClienteLevantamiento {
  try {
    return window.localStorage.getItem(CLAVE_CLIENTE) === 'yichang' ? 'yichang' : 'pg';
  } catch {
    // Ventana privada, almacenamiento bloqueado o lleno: se abre en P&G, como siempre.
    return 'pg';
  }
}

/**
 * Registros de campo · **Levantamiento de información** (`/panel/levantamiento-pg`).
 *
 * Antes era «Levantamiento P&G». Desde el 30-set entra también **Yichang** (Pringles y Kellogg's), y
 * el primer control de la pantalla es el cliente. La ruta y la clave de permiso (`levantamientoPg`)
 * **no cambian**, por el mismo criterio que «Registros de campo» mantiene `/panel/canjes`: es un
 * cambio de rótulo, no de estructura, y cambiar la URL rompería los enlaces guardados.
 *
 * ⚠️ **Ninguno de los dos es el levantamiento de SOFTYS**, que es otro estudio (las once tablas
 * `levantamiento_*`, en pausa desde agosto, ruta `/panel/levantamiento`). La confusión ya costó caro
 * el 15-set; por eso la pantalla nombra siempre el estudio que se está mirando.
 *
 * P&G se ve **exactamente** como antes: es el mismo componente. Cambiar de cliente desmonta uno y
 * monta el otro (render condicional, no `hidden`: cualquier `display` propio le gana al atributo).
 */
export default function LevantamientoInformacion() {
  const [cliente, setCliente] = useState<ClienteLevantamiento>(clienteGuardado);

  const elegir = (c: ClienteLevantamiento) => {
    setCliente(c);
    try { window.localStorage.setItem(CLAVE_CLIENTE, c); } catch { /* sin almacenamiento: no se recuerda, y ya */ }
  };

  return (
    <div>
      <h2 className="mb-1 text-lg font-semibold text-gray-900">Levantamiento de información</h2>
      <p className="mb-3 max-w-3xl text-sm text-gray-600">
        Las fichas de los formularios de levantamiento de campo. Elige el cliente: cada uno tiene sus instrumentos,
        sus preguntas y sus marcas.
      </p>
      <label className="mb-4 block text-sm">
        Cliente
        <select
          aria-label="Cliente"
          value={cliente}
          onChange={(e) => elegir(e.target.value === 'yichang' ? 'yichang' : 'pg')}
          className="mt-1 block rounded border px-2 py-1.5"
        >
          <option value="pg">P&amp;G</option>
          <option value="yichang">Yichang · Pringles y Kellogg&apos;s</option>
        </select>
      </label>
      <div className="border-t border-gray-200 pt-4">
        {cliente === 'pg' ? <LevantamientoPgBandeja /> : <LevantamientoYichangBandeja />}
      </div>
    </div>
  );
}
